import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Bread } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await register(form.name, form.email, form.password);
      toast.success("Verification code sent to your email");
      navigate("/verify", { state: { email: form.email } });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-6" data-testid="register-page">
      <div className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-8 shadow-sm">
        <div className="mb-6 flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-md bg-[#EA580C]">
            <Bread size={20} weight="duotone" className="text-white" />
          </div>
          <span className="font-heading text-lg font-bold text-slate-900">BakeFlow</span>
        </div>
        <h2 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Create account</h2>
        <p className="mt-1 text-sm text-slate-500">You'll receive a verification code by email</p>

        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="register-form">
          {error && <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="register-error">{error}</div>}
          <div className="space-y-1.5">
            <Label htmlFor="name">Full name</Label>
            <Input id="name" data-testid="register-name-input" required value={form.name} onChange={set("name")} placeholder="Priya Sharma" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="register-email-input" type="email" required value={form.email} onChange={set("email")} placeholder="you@company.com" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <Input id="password" data-testid="register-password-input" type="password" required minLength={6} value={form.password} onChange={set("password")} placeholder="Min. 6 characters" />
          </div>
          <Button type="submit" disabled={loading} data-testid="register-submit-button" className="w-full bg-[#EA580C] font-semibold text-white hover:bg-[#C2410C]">
            {loading ? "Sending code…" : "Create account"}
          </Button>
        </form>

        <p className="mt-6 text-sm text-slate-500">
          Already registered?{" "}
          <Link to="/login" data-testid="goto-login-link" className="font-semibold text-[#EA580C] hover:text-[#C2410C]">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
